<template>
  <v-select
    v-model="form"
    :items="coins"
    item-text="name"
    item-value="id"
    filled dense flat solo
    required
    class="rounded-0"
    background-color="grey400" color="grey100"
    item-color="primary500"
    label="Coin theme"
    hide-details
    :rules="[v => !!v || 'Required']"
    :menu-props="{'offset-y': true, nudgeBottom: 3, right: true}"
  >
    <template #selection="{item}">
      <div class="d-flex align-center">
        <v-img
          :src="item[0].image"
          :width="24" aspect-ratio="1"
          class="flex-grow-0 mr-n3"
        />
        <v-img
          :src="item[1].image"
          :width="24" aspect-ratio="1"
          class="flex-grow-0 mr-2"
        />
        <span v-t="item.name" class="text-caption font-weight-bold text-truncate" />
      </div>
    </template>

    <template #item="{item, on, attrs}">
      <v-list-item
        class="rounded-0 d-flex align-center px-2"
        v-bind="attrs" :ripple="false" v-on="on"
      >
        <v-img
          :src="item[0].image"
          :width="24" aspect-ratio="1"
          class="flex-grow-0 mr-n3"
        />
        <v-img
          :src="item[1].image"
          :width="24" aspect-ratio="1"
          class="flex-grow-0 mr-2"
        />
        <span v-t="item.name" class="text-caption font-weight-bold text-truncate" />
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    coins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: this.value,
    }
  },
  watch: {
    value(val) {
      if (val === this.form) return
      this.form = val
    },
    form(val) {
      if (val === this.value) return
      this.$emit('input', val)
    },
  },
}
</script>
